import { FormViewModel } from "../../Store/FormViewModel";
import { IReadonlyModelHunk } from "../IReadonlyModelHunk";
import { deleteIn } from "../../../../Helpers/ReduxStateHelpers";
import { AbsoluteModelPath } from "../../../../../../Common/ModelPath/ModelPath";

function removeViewModelNode(state: FormViewModel, modelPath: AbsoluteModelPath): FormViewModel {
    return deleteIn(state, modelPath.getSimpleTokensAsArrayStrict(), ".");
}

export function mergeViewModel(
    viewModelState: FormViewModel,
    values: IReadonlyModelHunk,
    deleted: AbsoluteModelPath[]
): FormViewModel {
    const nextViewModelState = deleted.reduce(removeViewModelNode, viewModelState);
    return values.mergeIntoViewModel(nextViewModelState);
}
